import { defineComponent as _defineComponent } from 'vue'
import Dialog from "primevue/dialog";
import {StakingAction} from "@/components/staking/StakingAction";
import {useConfigurationStore} from "@/store/configuration.store";
import {useUserStore} from "@/store/user.store";
import PercentsView from "@/components/commons/PercentsView.vue";
import WarningMessage from "@/components/commons/WarningMessage.vue";
import AmountView from "@/components/commons/AmountView.vue";
import LoginPopUp from "@/components/layout/loginPopup/LoginPopUp.vue";
import ValidatorLogo from "@/components/commons/ValidatorLogo.vue";
import {Field, Form} from "vee-validate";
import StakingRedelegate from "@/components/staking/StakingRedelegate.vue";
import StakingActionVue from "@/components/staking/StakingAction.vue";
import C4EIcon from "@/components/commons/C4EIcon.vue";
import StakeManagementIcon from "@/components/commons/StakeManagementIcon.vue";
import {computed, onUnmounted, ref, watch} from "vue";
import {Validator} from "@/models/store/validator";
import {object, setLocale, string} from "yup";
import i18n from "@/plugins/i18n";
import {YupSequentialStringSchema} from "@/utils/yup-utils";
import {RedelegationDirection} from "@/components/staking/StakingRedelegate";
import {BigDecimal} from "@/models/store/big.decimal";
import {formatBigNumberLocalized} from "@/utils/locale-number-formatter";
import {useValidatorsStore} from "@/store/validators.store";


const freeMultiplier = 1.2;

// const commissionForOperation = computed(() => {
//   return (Number(amount.value)/100) * Number(getPercents(props.validator.commission.rate)) || 0;
// });



export default /*#__PURE__*/_defineComponent({
  __name: 'StakingPopupModal',
  props: {
    visible: { type: Boolean, required: true },
    validator: { type: Object, required: true },
    redelegationDirection: { type: String, required: true }
  },
  emits: ['close', 'success'],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();


const props = __props;
const emit = __emit;


const loginPopupStatus = ref(false);
document.body.style.overflow = "hidden";
onUnmounted(() => {
  document.body.style.overflow = "auto";
});

const fee = ref(0);
const reserveCoins = ref(true);
const redelegateValidator = ref<Validator>();
const stakingAction = ref<StakingAction>(StakingAction.DELEGATE);

const canModify = computed<boolean>(() => {
  return useUserStore().isLoggedIn && useUserStore().connectionInfo.modifiable;
});

const amount = ref(0);
const usedGas = ref (0);
const showReserveCheckbox = ref(false);
const reservedCoins = useConfigurationStore().config.getConvertedAmount(useConfigurationStore().config.getReservedCoinsAmount());
setLocale({
  mixed: {
    defined: i18n.global.t('STAKING_VIEW.STAKING_POPUP.AMOUNT.REQUIRED'),
  }
});

const baseSchema = object().shape({
  redelegateValidator: object().nullable().test('validator', i18n.global.t('STAKING_VIEW.STAKING_POPUP.VALIDATOR.REQUIRED'), (value: any) => {
    return stakingAction.value === StakingAction.REDELEGATE ? value ? true : false : true;
  }),
  amount: YupSequentialStringSchema([string().defined(),
    string().test('not-empty', i18n.global.t('STAKING_VIEW.STAKING_POPUP.AMOUNT.REQUIRED'), (value: string | undefined) => {
      return value ? value.length > 0 : false;
    }),
    string().matches(/^\d*(\.\d{0,6})?$/gm, i18n.global.t('STAKING_VIEW.STAKING_POPUP.AMOUNT.NUMBER', {decimal: useConfigurationStore().config.getViewDenomDecimals()})),
    string().test('delgation-moreThan', i18n.global.t('STAKING_VIEW.STAKING_POPUP.AMOUNT.MIN'), moreThan),
    string().test('delgation-lessThan', () => i18n.global.t('STAKING_VIEW.STAKING_POPUP.AMOUNT.MAX', {max: maxAmountMessageData()}), lessThanOrEqualTo)
  ])
});

function transferAllAmount() {
  // const commission = getPercents(props.validator.commission.rate);
  // if (commission) {
  switch (stakingAction.value) {
    case StakingAction.DELEGATE:
      showReserveCheckbox.value = true;
      // amount.value = Number(useConfigurationStore().config.getConvertedAmount(useUserStore().getBalance));
      simulateDelegation();
      break;
    case StakingAction.UNDELEGATE:
      amount.value = Number(useConfigurationStore().config.getConvertedAmount(props.validator.delegatedAmount));
      break;
    case StakingAction.REDELEGATE:
      if (props.redelegationDirection === RedelegationDirection.FROM && redelegateValidator.value) {
        amount.value = Number(useConfigurationStore().config.getConvertedAmount(redelegateValidator.value?.delegatedAmount));
      } else if (props.redelegationDirection === RedelegationDirection.TO) {
        amount.value = Number(useConfigurationStore().config.getConvertedAmount(props.validator.delegatedAmount));
      } else {
        amount.value = 0;
      }
      break;
  }
  // } else {
  //   console.log(1);
  // }

}

// function getPercents(amount: bigint | number | BigDecimal) {
//
//   if (typeof amount === 'number') {
//     if (isNaN(amount)) {
//       return Number.NaN;
//     }
//     return amount * 100;
//   } else if (typeof amount === 'bigint') {
//     return amount * 100n;
//   } else {
//     return amount.multiply(100);
//   }
// }

function checkValue(value: string | undefined, check: (value: string) => boolean): boolean {
  if (!value) {
    return false;
  }
  try {
    return check(value);
  } catch (err) {
    return false;
  }
}

function moreThan(value: string | undefined): boolean {
  return checkValue(value, (value: string) => (new BigDecimal(value)).isBiggerThan(0));
}

function lessThanOrEqualTo(value: string | undefined): boolean {
  return checkValue(value, (value: string) => {
    const factor = useConfigurationStore().config.getViewDenomConversionFactor();
    let lessThan;
    switch (stakingAction.value) {
      case StakingAction.DELEGATE:
        lessThan = useUserStore().getBalance;
        break;
      case StakingAction.UNDELEGATE:
        lessThan = props.validator.delegatedAmount;
        break;
      case StakingAction.REDELEGATE:
        props.redelegationDirection === RedelegationDirection.FROM ?
          lessThan = redelegateValidator.value?.delegatedAmount : lessThan = props.validator.delegatedAmount;
        break;
    }
    return (new BigDecimal(lessThan)).isBiggerThanOrEqualTo(new BigDecimal(value).multiply(factor));
  });

}

function maxAmountMessageData(): string {
  const amount = stakingAction.value === StakingAction.DELEGATE ?
    useConfigurationStore().config.getConvertedAmount(useUserStore().getBalance) :
    useConfigurationStore().config.getConvertedAmount(props.validator.delegatedAmount);
  return formatBigNumberLocalized(amount.toFixed(useConfigurationStore().config.getViewDenomDecimals()));
}

function action() {
  switch (stakingAction.value) {
    case StakingAction.DELEGATE: {
      delegate();
      break;
    }
    case StakingAction.UNDELEGATE: {
      undelegate();
      break;
    }
    case StakingAction.REDELEGATE: {
      redelegate();
      break;
    }
  }
}

function getValidatorDst(isRedelegate = false) {

  if (!isRedelegate || props.redelegationDirection === RedelegationDirection.FROM) {
    return props.validator.operatorAddress;
  }
  return redelegateValidator.value?.operatorAddress;
}

function getValidatorSrc(isRedelegate = false) {
  if (isRedelegate && props.redelegationDirection === RedelegationDirection.FROM) {
    return redelegateValidator.value?.operatorAddress;
  }
  return props.validator.operatorAddress;
}

async function delegate() {
  const dst = getValidatorDst();
  if (dst && usedGas.value !== 0 ) {
    await useUserStore().delegate(dst, amount.value, Math.ceil(usedGas.value))
      .then((resp) => {
        console.log(resp);
        emit('success');
      });
  } else if(dst && usedGas.value === 0){
    await useUserStore().delegate(dst, amount.value)
      .then((resp) => {
        console.log(resp);
        emit('success');
      });
  }
}

async function simulateDelegation(){
  const dst = getValidatorDst();
  if (dst) {
    await useUserStore().simulateDelegation(dst, Number(useConfigurationStore().config.getConvertedAmount(useUserStore().getBalance))).then((res) => {
      console.log("predicted gas usage:" + res);
      usedGas.value = Number(Number(Number(res)  * freeMultiplier).toFixed(6));
      console.log("predicted usedGas multiplied:" + usedGas.value);
      fee.value = Number((Number(useConfigurationStore().config.getConvertedAmount((Number(res) * useConfigurationStore().config.getGasPrise()))) * freeMultiplier).toFixed(6));
      console.log("fee:" + fee.value);
      amount.value = Number(useConfigurationStore().config.getConvertedAmount(useUserStore().getBalance)) - fee.value;
      if(reserveCoins.value){
        amount.value -= Number(reservedCoins);
      }
      amount.value = Math.floor(amount.value * 1000000)/1000000;
      // fee.value = Number(res) * useConfigurationStore().config.getGasPrise();
      // amountWithCommission.value = useConfigurationStore().config.getConvertedAmount(
      //   (useConfigurationStore().config.getReservedCoinsAmount() + (Number(res) * useConfigurationStore().config.getGasPrise()))).toFixed(6);
      // amountWithCommission.value = Number(useConfigurationStore().config.getConvertedAmount(useConfigurationStore().config.getReservedCoinsAmount()).toFixed(6));
      // if (reserveCoins.value) {
      //   reserveCoinsForFee(amountWithCommission.value + (Number(res) * useConfigurationStore().config.getGasPrise()), true);
      // }
    });
  } else {
    fee.value = 0;
    // amountWithCommission.value = 0;
  }
}

watch(reserveCoins, (next, prev) => {
  if (next) {
    amount.value -= Number(reservedCoins);
  } else {
    amount.value += Number(reservedCoins);
  }
});

watch(stakingAction, (next, prev) => {
  amount.value = 0;
  showReserveCheckbox.value = false;
});

// function reserveCoinsForFee(reserved: number, increase: boolean) {
//   const reserve = Number(Number(Number(amount.value) - reserved).toFixed(6));
//   amount.value = reserve;
// }

async function undelegate() {
  const dst = getValidatorDst();
  if (dst) {
    await useUserStore().undelegate(dst, amount.value).then(() => {
      emit('success');
    });
  } // TODO else
}

async function redelegate() {
  const dst = getValidatorDst(true);
  const src = getValidatorSrc(true);
  if (dst && src) {
    useUserStore().redelegate(src, dst, amount.value).then(() => {
      emit('success');
    });
  }
}

const amountToPass = computed(() => {
  let coins = [];
  switch (stakingAction.value) {
    case StakingAction.DELEGATE: {
      coins = [];
      coins.push(
        {amount: props.validator.delegatedAmount, header: i18n.global.t('STAKING_VIEW.STAKING_POPUP.DELEGATED')},
        {amount: useUserStore().getBalance || 0, header: i18n.global.t('STAKING_VIEW.STAKING_POPUP.AVAILABLE_TO_DELEGATE')});
      break;
    }
    case StakingAction.UNDELEGATE: {
      coins = [];
      coins.push({amount: props.validator.undelegatingAmount, header: i18n.global.t('STAKING_VIEW.STAKING_POPUP.UNDELEGATED')}, {
        amount: props.validator.delegatedAmount,
        header: i18n.global.t('STAKING_VIEW.STAKING_POPUP.DELEGATED')
      });
      break;
    }
    case StakingAction.REDELEGATE: {
      coins = [];
      coins.push({amount: props.validator.delegatedAmount, header: i18n.global.t('STAKING_VIEW.STAKING_POPUP.DELEGATED')});
      break;
    }
    default:
      coins = [];
      coins.push(0);
      break;
  }
  return coins;
});

const timeToComplete = computed(() => {
  return useValidatorsStore().getParamsUnbondingTime;
});

// function getWarningParams() {
//   return {timeToComplete: useValidatorsStore().getParamsUnbondingTime};
// }

const __returned__ = { props, emit, loginPopupStatus, fee, reserveCoins, redelegateValidator, stakingAction, canModify, amount, usedGas, showReserveCheckbox, reservedCoins, freeMultiplier, baseSchema, transferAllAmount, checkValue, moreThan, lessThanOrEqualTo, maxAmountMessageData, action, getValidatorDst, getValidatorSrc, delegate, simulateDelegation, undelegate, redelegate, amountToPass, timeToComplete, get Dialog() { return Dialog }, get StakingAction() { return StakingAction }, get useConfigurationStore() { return useConfigurationStore }, get useUserStore() { return useUserStore }, PercentsView, WarningMessage, AmountView, LoginPopUp, ValidatorLogo, get Field() { return Field }, get Form() { return Form }, StakingRedelegate, StakingActionVue, C4EIcon, StakeManagementIcon }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})